import { ApiPostRequest } from './api-post-request';
import { Order } from '../../interfaces/order';
import { ApiParameters } from './api-parameters';
import { TicketPackage } from '../../interfaces/ticket-package';

export class PackageAddReservationRequest extends ApiPostRequest
{
    public constructor(order: Order, ticketPackage: TicketPackage, count: number, webapiBasepath: string)
    {
        const parameters = new ApiParameters()
            .addQueryParameter('orderid', order.Id)
            .addQueryParameter('packageid', ticketPackage.Id)
            .addQueryParameter('count', count);

        super('packagereservation', parameters, null, null, webapiBasepath);
    }
}
